const subscriptionsModule = {
  state: {
    items: null,
    pagination: null
  },
  mutations: {
    setSubscriptions(state, data) {
      state.items = data
    },
    setSubscriptionsPagination(state, data) {
      state.pagination = data
    }
  },
  actions: {

  },
  getters: {
    getSubscriptions: (state) => {
      return state.items
    },
    getSubscriptionsPagination: (state) => {
      return state.pagination
    }
  }
}

export default subscriptionsModule



// WEBPACK FOOTER //
// ./src/store/modules/subscriptions.js